import { render, staticRenderFns } from "./BookAddressForm.vue?vue&type=template&id=55ed37ce&"
import script from "./BookAddressForm.vue?vue&type=script&lang=js&"
export * from "./BookAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports